const newsletterForm = document.getElementById('newsletter-form')
const emailInput = document.getElementById('email')
const feedback = document.getElementById('newsletter-feedback')

// Replace these with your Mailchimp API details
const mailchimpAPIUrl =
  'https://us9.api.mailchimp.com/3.0/lists/50b040f1f5/members'
const apiKey = '<71544f2a47946478ae48f96d6c0aec05-us9>'

// Submit form handler
newsletterForm.addEventListener('submit', async (event) => {
  event.preventDefault() // Prevent default form submission

  const email = emailInput.value

  // Mailchimp API payload
  const data = {
    email_address: email,
    status: 'subscribed',
  }

  try {
    const response = await fetch(mailchimpAPIUrl, {
      method: 'POST',
      headers: {
        Authorization: `apikey ${apiKey}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })

    if (response.status === 200 || response.status === 204) {
      feedback.textContent = 'Thank you for subscribing!'
      feedback.style.color = 'green'
      emailInput.value = '' // Clear the input field
    } else {
      const errorData = await response.json()
      feedback.textContent =
        errorData.detail || 'Failed to subscribe. Please try again.'
      feedback.style.color = 'red'
    }
  } catch (error) {
    feedback.textContent = 'An error occurred. Please try again later.'
    feedback.style.color = 'red'
  }
})
